import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth, useRestaurant } from '../../hooks';
import { useSubscription } from '../../context/SubscriptionContext';
import { getOwnerHomePath } from '../../utils/ownerDefaultRoute';
import { SubscriptionExpiredMessage } from './SubscriptionExpiredMessage';

export function SubscriptionGuard({ children }) {
    const { isAuthenticated, isInitialized, user } = useAuth();
    const { isLoading, hasActiveSubscription } = useSubscription();
    const { restaurants, restaurantsLoaded } = useRestaurant();
    const location = useLocation();

    if (!isInitialized || isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        return children;
    }

    const hasSubscription = hasActiveSubscription();
    const isOwnerRole = user?.role === 'owner';

    if (!isOwnerRole && !hasSubscription) {
        return <SubscriptionExpiredMessage />;
    }

    if (location.pathname === '/select-subscription' && hasSubscription) {
        if (isOwnerRole) {
            if (!restaurantsLoaded) {
                return (
                    <div className="min-h-screen flex items-center justify-center">
                        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
                    </div>
                );
            }
            return <Navigate to={getOwnerHomePath(restaurants)} replace />;
        }
        return <Navigate to="/orders" replace />;
    }

    if (isOwnerRole && location.pathname !== '/select-subscription' && !hasSubscription) {
        return <Navigate to="/select-subscription" replace />;
    }

    if (!isOwnerRole && location.pathname === '/select-subscription') {
        return <Navigate to="/orders" replace />;
    }

    return children;
}
